import React from "react";
import {
  FaBalanceScale,
  FaGavel,
  FaLanguage,
  FaUniversity,
} from "react-icons/fa";
import Image from "../../assets/photo_2026-03-28_11-24-57.jpg";

const features = [
  {
    icon: <FaUniversity />,
    title: "Judicial Heritage",
  },
  {
    icon: <FaBalanceScale />,
    title: "Legislative Drafting",
  },
  {
    icon: <FaGavel />,
    title: "Cassation Expertise",
  },
  {
    icon: <FaLanguage />,
    title: "Multilingual Services",
  },
];

export default function AboutFirm() {
  return (
    <section className="bg-[#f7f7f7] py-20 px-6 lg:px-20">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-24 items-center">
        {/* IMAGE SIDE */}
        <div className="relative overflow-visible">
          {/* gold corner border */}
          <div className="absolute -right-6 top-6 w-full h-full border-2 border-yellow-500 rounded-xl z-0"></div>

          {/* image */}
          <div className="relative z-10 rounded-xl overflow-hidden shadow-xl">
            <img
              src={Image}
              alt="Lawyers"
              className="w-full h-auto object-contain"
            />
          </div>

          {/* badge */}
          <div className="absolute -bottom-14 right-0 md:-right-10 z-20 bg-[#0b2c55] text-white w-32 h-32 rounded-full flex flex-col items-center justify-center shadow-xl border-4 border-yellow-500">
            <h3 className="text-2xl font-bold">AD</h3>
            <p className="text-xs text-center leading-tight mt-1">
              Aderaw Addisu
              <br />
              ONE VISION
            </p>
          </div>
        </div>

        {/* TEXT SIDE */}
        <div>
          <div className="max-w-3xl mx-auto text-center">
            {/* subtitle */}
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="w-10 h-[2px] bg-yellow-600"></span>
              <p className="text-xs tracking-[0.3em] text-yellow-600 uppercase font-semibold">
                About Our Firm
              </p>
            </div>

            {/* title */}
            <h2 className="text-4xl lg:text-5xl font-bold leading-tight text-[#243a5e]">
              Founded by Aderaw
              <span className="block text-yellow-600">
                Distinguished Judges
              </span>
            </h2>

            {/* underline */}
            <div className="flex justify-center mt-4 mb-6">
              <span className="w-14 h-[3px] bg-blue-800"></span>
            </div>

            {/* description */}
            <p className="text-gray-600 leading-relaxed max-w-2xl mx-auto mb-10">
              <span className="font-semibold text-gray-800">
                Insightful Legal Counsel
              </span>{" "}
              Our practice areas include corporate law, contract preparation and
              negotiation, litigation, arbitration, property and real estate
              matters, employment law, immigration services, and human rights
              advocacy.
            </p>

            {/* feature list */}
            <div className="grid grid-cols-2 gap-4">
              {features.map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 bg-gray-200 px-6 py-4 relative"
                >
                  {/* gold divider */}
                  <span className="absolute left-0 top-0 h-full w-[3px] bg-yellow-600"></span>

                  {/* icon */}
                  <div className="text-yellow-600 text-lg ml-2">
                    {item.icon}
                  </div>

                  {/* text */}
                  <p className="text-[#243a5e] font-medium text-sm">
                    {item.title}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* partners */}
          <div className="mt-10 pt-6 border-t">
            <p className="text-xs uppercase tracking-wider text-gray-400 mb-2">
              Our Founding Partners
            </p>

            <p className="text-gray-700 text-sm">
              Aderaw Adisu • Almaw Wolie • Alemu Korme • Amare Ashenafi •
              Ashenafi Yirga
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
